<template>
    <aside class="sidebar product--sidebar" @click.prevent="toggleFilterClose($event)">
        <!-- end /.sidebar-card -->

        <div class="product--sidebar-wrapper" ref="wrapper" >
            <div class="sidebar-card card--filter" v-for="f in 4" ></div>
        </div>


    </aside>
</template>

<script>

import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
    name: "FilterSkeleton",

    computed: {

        ...mapGetters({ sliceState: 'sliceByKey' }),

        toggleFilter() { return this.sliceState( 'toggleFilter' ) },


    },
    methods:{
        ...mapMutations({ setState: 'setterByKey' }),
        toggleFilterClose(e){

            if (window.matchMedia("min-width: 992px").matches) return;

            const wrapper = this.$refs.wrapper;

            if( ! wrapper.contains( e.target ) ){
                this.setState( { key: 'toggleFilter', data: false });
                document.body.classList.remove('product-sidebar--open');
            }

        },

    }

}
</script>

<style lang="scss" scoped>

.sidebar-card:empty {
    margin: 0 0 25px;
    width: 100%;
    height: 300px; /* change height to see repeat-y behavior */

    background-image:
        linear-gradient( 100deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0) 80% ),
        linear-gradient( lightgray 20px, transparent 0 ),
        linear-gradient( lightgray 20px, transparent 0 ),
        linear-gradient( lightgray 20px, transparent 0 ),
        linear-gradient( lightgray 20px, transparent 0 );

    background-repeat: no-repeat;

    background-size:
        50px 200px,
        45% 200px,
        80% 200px,
        70% 200px,
        60% 200px;

    background-position:
        0 20px, /* highlight */
        20px 20px,
        20px 60px,
        20px 100px,
        20px 140px;

    animation: shine 1.5s infinite;


}

@keyframes shine {
    to {
        background-position:
            100% 20px, /* highlight */
            20px 20px,
            20px 60px,
            20px 100px,
            20px 140px;
    }
}

</style>

